/**
 * @generated SignedSource<<5ab47e62825ed5322f6bb09b8550241b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubmitCreativeForApprovalConfirmDialogBrand$data = {
  readonly id: string;
  readonly invalidDraftMetaAdCount: number;
  readonly " $fragmentType": "SubmitCreativeForApprovalConfirmDialogBrand";
};
export type SubmitCreativeForApprovalConfirmDialogBrand$key = {
  readonly " $data"?: SubmitCreativeForApprovalConfirmDialogBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubmitCreativeForApprovalConfirmDialogBrand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubmitCreativeForApprovalConfirmDialogBrand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invalidDraftMetaAdCount",
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "ff84ad9d976b3134a777ad5379fa5605";

export default node;
